<template>
  <div class="add-user">
    <button-toolbar
        :items="items"
        :status="status"
        @add-item-click="handleAddItemClick"
        @search-input="handleSearchInput"
    />
    <data-table
        style="margin-top: 25px;"
        :profile="profile"
        :items="items"
        :fields="fields"
    />
  </div>
</template>

<script>
import ButtonToolbar from "./buttonToolbar";
import DataTable from "./dataTable";
export default {
  name: "Items_Management_Table",
  components: {
    ButtonToolbar,
    DataTable
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    fields: {
      type: Array,
      default: () => {
        return [];
      }
    },
    items: {
      type: Array,
      default: () => {
        return [];
      }
    },
    itemId: {
      type: String,
      default: "add-edit-item-status"
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleSearchInput(){},
    handleAddItemClick() {
      this.$emit("add-item-click");
    },
    handleLogoUploadedURL(idx, url) {
      debugger;
      this.imgURL = url;
    },
    input(val) {
      this.description = val.content;
    },
    resetClear() {
      this.clear = false;
    }
  },
  data() {
    return {
      status: null, //|all | submitted | needs_work | inactive
      clear: false,
      idx: 0,
      storagePath: "providers_logos_imgs",
      isUpdate: false,
      name: null,
      description: [],
      brand: null,
      url: null,
      comment: null,
      imgURL: null,
      providerData: null
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>
